import useCurrencyStore from "store/currencyStore";
import { formatCurrencyAmount } from "utils";
import usePrice from "hooks/usePrice";
import React from "react";

const Price = ({ isFree, usdPrice, zwlPrice, sellable, prices }) => {
	const { currency } = useCurrencyStore();
    const price = usePrice({
		isFree,
		usdPrice,
        prices,
		zwlPrice,
		sellable,
	});

	return <>{price === null ? "Price unavailable" : formatCurrencyAmount(price, currency)}</>;
};

export default Price;
